import { defineSlotRecipe } from '@chakra-ui/react';

// v2's Checkbox had `defaultProps.colorScheme: 'blue'`; v3 has no per-component
// default, so the checked fill falls through to the global `gray` palette and
// renders black. Pinned on root the same way switch.ts and badge.ts do it.
const checkboxSlotRecipe = defineSlotRecipe({
  slots: ['root', 'control', 'label'],
  base: {
    root: {
      colorPalette: 'blue',
    },
    control: {
      _checked: {
        _disabled: {
          bg: '#E8E8E8',
          border: '1.2px solid #DDDEDF',
          color: '#C4C4C4',
        },
      },
    },
  },
  // v2's md label was 16px, v3's is 14px. Control stays at v3's 20px (v2: 16px)
  // by decision, so only the label is restored. Size variant, not base — stock
  // puts its label textStyle in `size.md` and variants win.
  variants: {
    size: {
      md: { label: { textStyle: 'md' } },
    },
  },
});

export default checkboxSlotRecipe;
